import { render } from "./TabView.vue?vue&type=template&id=eb1bb29a&scoped=true"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"

import "./TabView.vue?vue&type=style&index=0&id=eb1bb29a&scoped=true&lang=css"
import "./TabView.vue?vue&type=style&index=1&id=eb1bb29a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1bb29a"]])

export default __exports__